__turbopack_context__.v({
  "className": "hakgyoansimdunggeunmisoregular_e50458cd-module__qPq4ha__className",
  "variable": "hakgyoansimdunggeunmisoregular_e50458cd-module__qPq4ha__variable",
});
